"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var FooterSection = function FooterSection(_ref) {
  var className = _ref.className,
      open = _ref.open,
      children = _ref.children;
  var cname = 'FooterSection';

  if (className) {
    cname += ' ' + className;
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: cname
  }, children);
};

exports.FooterSection = FooterSection;